<template>
  <div class="absi-modal-wrapper">
    <slot name="activator"></slot>
    <b-modal
      ref="absi-modal"
      :no-close-on-backdrop="noCloseBackdrop"
      :no-close-on-esc="noCloseBackdrop"
      centered
      class="absi-modal"
      :id="modalName"
      :hide-header="hideHeader"
      hide-footer
    >
      <slot :hideModal="hideModal"></slot>
    </b-modal>
  </div>
</template>

<script>
// There is three different ways to add a click or toggle event to this modal.
// 1: Use v-b-modal.modalName on the slotted activator element.
// 2: Use the hideModal(), to close the modal from within the modal itself, using v-slot:scope on the component
//    and adding it in front of the event: @click="scope.hideModal". From: https://vuejs.org/v2/guide/components-slots.html#Scoped-Slots
// 3: Send a boolean object through the openModal which is connected to a v-model which toggles the modal based on the boolean.

export default {
  name: "AbsiModal",
  props: {
    modalName: {
      // Added to the id to be able to use bootstrap vue's own events
      type: String,
      required: true,
    },
    noCloseBackdrop: {
      // Used to not close the modal by clicking the backdrop and esc
      type: Boolean,
      default: false,
    },
    hideHeader: {
      // Used to hide the header
      type: Boolean,
      default: false,
    },
  },
  methods: {
    hideModal() {
      // Used to close the modal from within template
      this.$refs["absi-modal"].hide();
    },
  },
};
</script>

<style lang="scss" scoped>
.absi-modal-wrapper {
  list-style-type: none;
}

#consent-modal {
  .modal-dialog {
    max-width: 400px;
  }
}
</style>